import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import Review from './review';
import st from '../../pages/testimonals/index.module.css';
const TestimonialsAboutProject = props => {
  const SampleNextArrow = props => {
    const { onClick } = props;
    return (
      <div className="cursor-pointer absolute" style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }} onClick={onClick}>
        <img src={'/images/icons/navbar-arrow.svg'} alt="navbar-arrow" />
      </div>
    );
  };
  const SamplePrevArrow = props => {
    const { onClick } = props;
    return (
      <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
        <img src={'/images/icons/navbar-arrow.svg'} alt="navbar-arrow" />
      </div>
    );
  };
  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: true,
    dotsClass: 'custom-dots',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <style>{`
                .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
                  @keyframes slide1 {
                      0%,
                      100% {
                        transform: translate(0, 0);
                      }
                    
                      50% {
                        transform: translate(10px, 0);
                      }
                    }
                    .jello-horizontal {
                          animation: slide1 1s ease-in-out infinite;
                    }
            `}</style>
      <Slider {...settings} className="relative z-10 mt-20  md:mx-0">
        {props.about.map((el, ind) => {
          return (
            <div key={'about_project_' + ind}>
              <div className={'flex flex-wrap w-full justify-between '}>
                <div className={'block md:hidden text-24 leading-none font-normal text-purple  mb-20'}>
                  {' '}
                  <span className={'font-bold text-black '}>Service:</span>Video Production{' '}
                </div>
                <div className="w-full md:w-half-auto pt-2 ">
                  {el.testimonial.type == 'image' && (
                    <img src={el.testimonial.video_image} className={'h-full w-full ' + st.video} alt="testimonial" />
                  )}
                  {el.testimonial.type == 'video' && (
                    <video className={'w-full'} controls poster={'https://weprodigi.com/' + el.testimonial?.thumbnail}>
                      <source src={'https://weprodigi.com/' + el.testimonial?.video_image} type="video/mp4" />
                      Your browser does not support HTML video
                    </video>
                  )}
                </div>
                <div className={'w-full md:w-half-auto pr-5'}>
                  <div className={'hidden md:block text-24 leading-none font-normal text-purple -mt-5px'}>
                    {' '}
                    <span className={'font-bold text-black ml-10'}>Service:</span>Video Production{' '}
                  </div>
                  <div className="mt-24 bg-white ">
                    <Review data={el.testimonial} />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </>
  );
};
export default TestimonialsAboutProject;
